<template>
  <div class="scrollable">
    <v-container class="pa-md-6 pa-3 fill-height align-start">
      <v-card class="d-flex flex-column mx-auto" width="100%" height="100%">
        <div class="pa-4 flex-grow-1 align-stretch">
          <pdf-js
            v-if="mediaUrl !== null"
            class="scroll-container"
            :url="mediaUrl"
            :page="$route.query.page"
            :search="$route.query.search"
            :download-file-name="downloadFileName"
            style="height: 100% !important"
          >
          </pdf-js>
        </div>
        <v-card-subtitle v-if="description.length > 0" class="pt-0 text-center">
          {{ description }}
        </v-card-subtitle>
        <v-card-text v-if="tags.length > 0" class="text-center">
          <span v-for="(tagId, i) in tags" :key="i">
            <v-chip v-if="tagsById[tagId]" class="mr-1" small>{{ tagsById[tagId].name }}</v-chip>
          </span>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import index from '../index';
import common from '@/mixins/common';
import PdfJs from '@/components/pdf/PdfJs';
import { mapState } from 'vuex';

export default {
  name: 'PDFViewer',
  emits: [],
  mixins: [common],
  components: { PdfJs },
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('media', ['tagsById']),
    mediaProperties() {
      return this.media.properties;
    },
    mediaFileName() {
      return this.mediaProperties.filename || '';
    },
    mediaChecksum() {
      return this.mediaProperties.checksum || '';
    },
    mediaUrl() {
      return this.moduleFileUrl(index.moduleId, this.mediaFileName, this.mediaChecksum);
    },
    properties() {
      return this.container.properties ? this.container.properties : {};
    },
    description() {
      return this.properties.description ? this.properties.description : '';
    },
    tags() {
      return this.container.tags && Array.isArray(this.container.tags) ? this.container.tags : [];
    },
    downloadFileName() {
      return this.media ? this.media.name : '';
    },
  },
};
</script>

<style>
iframe {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
iframe.dark {
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.PdfJs {
  position: relative;
}
.PdfJs button.right-btn {
  position: absolute !important;
  bottom: 10px !important;
}
</style>
